module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJkMDBhMTI0Mzc1MzRkM2I1Y2ZkYzE5MDZlOGIxOTc2My5zdmciOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/iconfont.svg
 ** module id = 226
 ** module chunks = 0
 **/